import api from '@/services/api/config';

const path = 'v1/prozesskontrollkarte/admin/prozesskontrollkarte';

export default {
  get: (page, size, sort = null, desc = false, suche = null, status = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche, status,
    },
  }),
  getPckMitFehlendenFunktionspruefungen: (page, size, sort = null, desc = false, suche = null, status = null) => api.get(`${path}/fehlende-funktionspruefungen`, {
    params: {
      page, size, sort, desc, suche, status,
    },
  }),
  getAnzahlPckMitFehlendenFunktionspruefungen: () => api.get(`${path}/fehlende-funktionspruefungen/anzahl`),
  getById: (id) => api.get(`${path}/${id}`),
  create: (prozesskontrollkarte) => api.post(path, prozesskontrollkarte),
  update: (id, prozesskontrollkarte) => api.put(`${path}/${id}`, prozesskontrollkarte),
  delete: (id) => api.delete(`${path}/${id}`),
  finalisieren: (id) => api.patch(`${path}/${id}/finalisieren`),
  archivieren: (id) => api.patch(`${path}/${id}/archivieren`),
  getGueltigkeitsbereichKollision: (id, gueltigAbParam, gueltigBisParam, artikelnummer, zeichnungsnummer, zeichnungsindex, abteilung, position) => api.get(`${path}/${id}/gueltigkeitsbereich/kollision`, {
    params: {
      gueltig_ab: gueltigAbParam, gueltig_bis: gueltigBisParam, artikelnummer, zeichnungsnummer, zeichnungsindex, abteilung, position,
    },
  }),
  getDocuments: (id) => api.get(`${path}/${id}/dokument`),
  addDocument: (id, formData) => api.post(`${path}/${id}/dokument`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  updateDocument: (id, dokumentId, formData) => api.put(`${path}/${id}/dokument/${dokumentId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  deleteDocument: (id, dokumentId) => api.delete(`${path}/${id}/dokument/${dokumentId}`),
  getFehlendeFunktionspruefungen: (id) => api.get(`${path}/${id}/fehlende-funktionspruefungen`),
};
